import { type PropsWithChildren } from "react";
import { faWarning } from "@fortawesome/free-solid-svg-icons";

import { Button, Modal } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function ConfirmationModal({
  title = "Confirmation",
  prompt = "Are you sure?",
  warning,
  confirmButtonText = "Confirm",
  confirmButtonEnabled = true,
  show,
  onShow,
  onConfirmed,
  children,
}: PropsWithChildren<{
  title?: string;
  prompt: string;
  warning?: string;
  confirmButtonText?: string;
  confirmButtonEnabled?: boolean;
  show: boolean;
  // eslint-disable-next-line no-unused-vars
  onShow: (visible: boolean) => void;
  onConfirmed: () => Promise<void>;
}>) {
  return (
    <Modal show={show} onHide={() => onShow(false)}>
      <Modal.Header closeButton className="bg-light">
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="bg-body-light">
        <p>{prompt}</p>
        <div className="mb-4">{children}</div>
        {warning && (
          <p className="text-body-secondary">
            <small>
              <em>
                <FontAwesomeIcon icon={faWarning} className="text-warning" />{" "}
                {warning}
              </em>
            </small>
          </p>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button
          variant="outline-secondary"
          onClick={() => {
            onShow(false);
          }}
        >
          Cancel
        </Button>
        <Button
          variant="danger"
          disabled={!confirmButtonEnabled}
          onClick={onConfirmed}
        >
          {confirmButtonText}
        </Button>
      </Modal.Footer>
    </Modal>
  );
}
